import React from 'react'
import Text from '../../../../components/Text'
import { colors } from '../../../../constants/colors'
import { offeringSection } from '../../../../constants/anaya-constants'

const OurProgram = () => {
  return (
    <section className="py-[41px] px-5 space-y-10">
      <div className="max-w-[330px] mx-auto pb-6">
        <Text
          tag="p"
          variant="headline"
          size="large"
          bold={'true'}
          className={`text-[${colors.TEXT_PRIMARY}]`}
        >
          Benefits our program offers you
        </Text>
      </div>
      <div className="space-y-10">
        {offeringSection?.offerings?.map((offering, index) => (
          <div key={`viemax-care-offerings-${index}`}>
            <img
              src={offering.image}
              alt={offering.title}
              className="mt-[8px] relative w-358"
            />
            <Text
              tag="p"
              variant="title"
              size="large"
              className="pl-[1.5px] mt-[12px] text-[#1F2933] font-[600]"
            >
              {offering.title}
            </Text>
            <Text
              tag="p"
              variant="body"
              size="large"
              className="text-[#5A6774] mt-3"
            >
              {offering.desc}
            </Text>
          </div>
        ))}
      </div>
    </section>
  )
}

export default OurProgram
